import { render, staticRenderFns } from "./PlacePicker.vue?vue&type=template&id=bdb544f0&scoped=true&"
import script from "./PlacePicker.vue?vue&type=script&lang=js&"
export * from "./PlacePicker.vue?vue&type=script&lang=js&"
import style0 from "./PlacePicker.vue?vue&type=style&index=0&id=bdb544f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb544f0",
  null
  
)

component.options.__file = "PlacePicker.vue"
export default component.exports